<template>
  <TemplateCrud>
    <li slot="breadcrumb" class="breadcrumb-item active" aria-current="page">
      Visão geral dos clientes
    </li>
    <div slot="body">
      <h4 class="py-2">Situação dos clientes</h4>
      <b-card-group deck class="py-4">
        <b-card
          border-variant="success"
          header="Ativos"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text
            ><h4>{{ active.count }}</h4></b-card-text
          >
        </b-card>

        <b-card
          border-variant="secondary"
          header="Inativo"
          header-bg-variant="secondary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text
            ><h4>{{ inactive.count }}</h4></b-card-text
          >
        </b-card>

      </b-card-group>
      <b-card-group deck class="py-4">
        <b-card
          border-variant="primary"
          header="Pendência financeira"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text
            ><h4>{{ financialPending.count }}</h4></b-card-text
          >
        </b-card>

        <b-card
          border-variant="warning"
          header="Bloqueio financeiro"
          header-bg-variant="warning"
          header-text-variant="white"
          align="center"
        >
          <b-card-text
            ><h4>{{ financialBlocking.count }}</h4></b-card-text
          >
        </b-card>

        <b-card
          border-variant="dark"
          header="Expirado"
          header-bg-variant="dark"
          header-text-variant="white"
          align="center"
        >
          <b-card-text
            ><h4>{{ expired.count }}</h4></b-card-text
          >
        </b-card>
      </b-card-group>
    </div>
  </TemplateCrud>
</template>

<script>
import request from "../request/request";
import TemplateCrud from "../template/TemplateCrud";
import StatsCard from "../components/cards/StatsCard";
import { companyCountPath } from "../router/ApiPaths";

export default {
  name: "Main",
  extends: request,
  components: {
    StatsCard,
    TemplateCrud
  },
  data() {
    return {
      active: { count: 0 },
      financialBlocking: { count: 0 },
      financialPending: { count: 0 },
      expired: { count: 0 },
      inactive: { count: 0 }
    };
  },
  mounted() {
    this.find();
  },
  methods: {
    findInList(list, status) {
      const result = list.find(e => {
        return e.status == status;
      });

      if (result) return result;
      return {count: 0};
    },
    find() {
      this.get(companyCountPath).then(data => {
        this.active = this.findInList(data, "A");
        this.financialBlocking = this.findInList(data, "F");
        this.financialPending = this.findInList(data, "P");
        this.expired = this.findInList(data, "E");
        this.inactive = this.findInList(data, "I");
      });
    }
  }
};
</script>

<style scoped>
.m-w20 {
  min-width: 25rem !important;
  margin-bottom: 1rem;
}

@media only screen and (max-width: 720px) {
  .m-w20 {
    min-width: 100% !important;
    margin-bottom: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Main.vue